module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec05_f5270cc006908bed30294d41904cd3cf.jpg";